<template>
    <text-dialog
            fullscreen
            :value.sync="dialog"
            :title="$t('select_dancers')"
            confirm
            :close-disabled="disabled"
            :confirm-disabled="selectedDancers.length === 0 || disabled"
            @ok="ok"
            :disabled="disabled"
    >
        <slot name="activator" slot="activator"></slot>
        <div slot="content">
            <v-checkbox
                v-model="generateInvoice"
                label="Rechnung erstellen"
                class="mb-2"
            ></v-checkbox>
            <dancer-list
                    :selectable="!disabled"
                    :selected.sync="selectedDancers"
                    :items="dancers"
                    :loading="loading"
            ></dancer-list>
        </div>
    </text-dialog>
</template>

<script>
    import { mapMutations } from 'vuex';
    import TextDialog from '../dialogs/TextDialog';
    import DancerList from '../user/DancerList';

    export default {
        components: {
            TextDialog,
            DancerList
        },
        data: () => ({
            dialog: false,
            loading: false,
            disabled: false,
            generateInvoice: true,
            dancers: [],
            selectedDancers: []
        }),
        watch: {
            dialog() {
                if (!this.dialog) {
                    this.reset();
                }
            }
        },
        props: {
            id: {
                type: Number,
                default: 0
            }
        },
        mounted() {
            this.loadDancers();
        },
        methods: {
            loadDancers() {
                this.loading = true;
                axios.get(`/api/v1/dancers`, {
                    params: {
                        event_registration_id: this.id
                    }
                }).then(response => {
                    if (!response.data.success) {
                        this.loading = false;
                        return;
                    }

                    this.$set(this, 'dancers', response.data.data);

                    this.loading = false;
                }, errorResponse => {
                });
            },
            reset() {
                this.$set(this, 'selectedDancers', []);
            },
            ok() {
                this.disabled = true;
                const ids = _.map(this.selectedDancers, d => d.id);
                axios.post(`/api/v1/event_registrations/${this.id}/late_registration`, {
                    dancers: ids,
                    generate_invoice: this.generateInvoice
                }).then(response => {
                    if (!response.data.success) {
                        this.disabled = false;
                        return;
                    }

                    this.disabled = false;
                    this.dialog = false;

                    this.$store.commit('snackBar', {
                        color: 'success',
                        text: 'Tänzer erfolgreich hinzugefügt'
                    });

                    this.$emit('ok', response.data.data);
                }, errorResponse => {
                    this.disabled = false;
                });
            },
            ...mapMutations(['snackBar'])
        }
    }
</script>
